import api from "./api";
import { entityRoute } from "./entityRoutes";

/**
 * Open a tagged record's page after asking the API whether this user may see it
 * (a recipient can have fewer rights than the sender). Resolves true when it navigated.
 */
export function openTag(vm, tag) {
  const route = entityRoute(tag.type, tag.id);
  if (!route) return Promise.resolve(false);

  return api
    .entity(tag.type, tag.id)
    .then((res) => {
      if (!res.can_open) {
        vm.$toasted.info("You don't have access to this record.", { position: "top-center", duration: 3000 });
        return false;
      }
      vm.$router.push(route).catch(() => {});
      return true;
    })
    .catch(() => {
      vm.$toasted.error("Couldn't open this record.", { position: "top-center", duration: 3000 });
      return false;
    });
}
